import { ConfigModel } from '../../models';

/**
 * The major config version of the current codebase (if lower than backend config version, loading will be skipped!)
 * @version 2 Added new global font-options and changed the existing ones
 * @version 3 Introduced a completely new structure for the header
 * @version 4 Introduced a completely new structure for the footer
 */
export const CONFIG_VERSION = 4;

/** Scale factor for the .p-small text style relative to the regular p (Fließtext) font-size */
export const P_SMALL_SCALE_FACTOR = 0.9;

/**
 * Whether a config from the backend or the server render can be applied: an object with a version up to
 * {@link CONFIG_VERSION}. A newer or missing version is skipped, the code does not know its structure.
 * @param config The loaded config.
 * @returns True when the config can be applied.
 */
export function isApplicableConfig(config: unknown): config is ConfigModel {
  if (!config || typeof config !== 'object') return false;
  const version = (config as Partial<ConfigModel>).version;
  return typeof version === 'number' && version <= CONFIG_VERSION;
}
